'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

// Deprecated
var GetDataApi = function (_BaseApi) {
  (0, _inherits3.default)(GetDataApi, _BaseApi);
  function GetDataApi() {
    (0, _classCallCheck3.default)(this, GetDataApi);
    return (0, _possibleConstructorReturn3.default)(this, (GetDataApi.__proto__ || Object.getPrototypeOf(GetDataApi)).call(this, _frontendUtils.endpoints.eecBaseUrl));
  }
  (0, _createClass3.default)(GetDataApi, [{
    key: 'openCommunication',
    value: function openCommunication(url, channelId) {
      if (!ValidationUtils.isNonEmptyOrBlankString(url)) {
        return Promise.reject(new _ParameterError2.default('url', url, 'non-empty string.'));
      }
      if (!ValidationUtils.isGuid(channelId)) {
        return Promise.reject(new _ParameterError2.default('channelId', channelId, 'guid string.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'url',
        body: {
          url: url,
          channelId: channelId
        }
      });
    }
  }, {
    key: 'getData',
    value: function getData(dataBufferId) {
      if (!ValidationUtils.isGuid(dataBufferId)) {
        return Promise.reject(new _ParameterError2.default('dataBufferId', dataBufferId, 'guid string.'));
      }
      return this.makeRequest({
        url: 'data/' + dataBufferId
      });
    }
  }]);
  return GetDataApi;
}(_BaseApi3.default);
exports.default = GetDataApi;